import { PolicyClaim } from './view';

export { default as PolicyClaimReducer } from './reducer';
export { default as PolicyClaimSaga } from './saga';

export default PolicyClaim;
